module.exports = __webpack_public_path__ + "img/wronglyTitle.4415fd6b.png";